var _path, _path2, _path3, _path4, _path5, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BBDEFB",
    d: "M29.5 5A8.5 8.5 0 1 0 29.5 22A8.5 8.5 0 1 0 29.5 5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBDEFB",
    d: "M37 14.893A7 7 0 1 0 37 28.893 7 7 0 1 0 37 14.893zM11 15A7 7 0 1 0 11 29 7 7 0 1 0 11 15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBDEFB",
    d: "M17.5 8A6.5 6.5 0 1 0 17.5 21A6.5 6.5 0 1 0 17.5 8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBDEFB",
    d: "M25 12.893A7 7 0 1 0 25 26.893A7 7 0 1 0 25 12.893Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBDEFB",
    d: "M7,25c0,2.209,1.791,4,4,4h25c2.209,0,4-1.791,4-4v-1c0-2.209-1.791-4-4-4H11c-2.209,0-4,1.791-4,4V25z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M23 34H25V43H23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M23 33.999H25V42.999H23z",
    transform: "rotate(120.471 24 38.499)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M23.001 34H24.999000000000002V43H23.001z",
    transform: "rotate(60.679 24 38.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M10 31H12V40H10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M10 30.999H12V39.998999999999995H10z",
    transform: "rotate(120.444 11 35.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M10.001 31H11.998999999999999V40H10.001z",
    transform: "rotate(60.679 11 35.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M36 31H38V40H36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M35.999 30.998H37.999V39.998000000000005H35.999z",
    transform: "rotate(120.458 36.999 35.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M36 31H37.998V40.001H36z",
    transform: "rotate(60.679 36.999 35.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.0ff11d7c.svg";
export { ForwardRef as ReactComponent };